var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text',{attrs:{"fill":_vm.color,"x":"90","y":"70","font-size":"100"}},[(_vm.suit === '1')?[_vm._v(" ♦ ")]:(_vm.suit === '2')?[_vm._v(" ♣ ")]:(_vm.suit === '3')?[_vm._v(" ♥ ")]:(_vm.suit === '4')?[_vm._v(" ♠ ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }